var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { addressToString } from '@debbie/common/dist';
import { BlameLogType } from '@debbie/common/dist/blamelog';
import { courtByCountryCode } from '@debbie/common/dist/court';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import Button from '../../Button';
import ButtonGroup from '../../ButtonGroup';
import SearchInput from '../../SearchInput';
import Well from '../../Well';
import UserInfoEntity from './UserInfoEntity';
const UserCourt = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const [courtId, setCourtId] = useState(null);
    useEffect(() => {
        if (details) {
            if (!courtId && details.courtId) {
                setCourtId(details.courtId);
            }
        }
    }, [details]);
    const courts = tenant && courtByCountryCode[tenant.countryCode];
    if (!courts)
        return null;
    return props.user.relation !== 'alternative-contact' ? (React.createElement(UserInfoEntity, { title: lang.debtorInfo.jurisdiction, value: details.courtId, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () { }), hist: details.courtIdHist, renderValue: (courtId) => {
            const court = courtId && courts.find((c) => c.id === courtId);
            return ((court && court.name) || (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noJurisdiction)));
        }, renderEditor: (selectedValue) => (React.createElement(Well, null,
            React.createElement(SearchInput, { placeholder: lang.debtorInfo.chooseJurisdiction, searchAll: (q) => {
                    return courts
                        .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) !== -1)
                        .map((c) => ({
                        key: c.id,
                        heading: c.name,
                        subheading: addressToString(c),
                        returnData: c.id,
                    }));
                }, static: (() => {
                    const court = courtId && courts.find((c) => c.id === courtId);
                    return court && court.name;
                })(), onRemoveStatic: () => setCourtId(null), onSelect: setCourtId, searchDelay: 0, forceOpen: true }),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { disabled: !courtId, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        courtId && selectedValue(courtId);
                        yield props.patchUser({
                            courtId,
                        }, {
                            details: courtId,
                            type: BlameLogType.DebtorUpdateCourt,
                        });
                    }), size: "small" }, lang.debtorInfo.save),
                React.createElement(Button, { theme: "secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        selectedValue(null);
                        yield props.patchUser({
                            courtId: null,
                        }, {
                            details: courtId,
                            type: BlameLogType.DebtorUpdateCourt,
                        });
                    }), size: "small" }, lang.debtorInfo.remove)))), removable: true })) : null;
};
export default UserCourt;
//# sourceMappingURL=UserCourt.js.map